import { Component, Directive, ElementRef, Renderer } from '@angular/core';
@Directive({
  selector: '[iframe-resize]',
host: {
    '(load)': 'onLoad()'
}
})
export class IframeResizeDirective {
    private elRef: ElementRef;
    constructor(element: ElementRef, renderer: Renderer) {
        this.elRef = element;
    }
    onLoad() {
        console.log('iframe loaded');
        let iFrameWidth = '85%';
        let iFrameHeight = '90%';
        this.elRef.nativeElement.style.width = iFrameWidth;
        this.elRef.nativeElement.style.height = iFrameHeight;
    }
}



// WEBPACK FOOTER //
// ./src/common/iframe-resize.directive.ts